import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { CustomDropDown } from "../DataComponent";

function scrollToFilteredItem(filterText) {
  if (filterText === "") return;
  if (filterText === null) return;
  if (filterText === undefined) return;

  const popupRef = document.querySelector(".k-animation-container .k-list-container");
  const filteredItems = Array.from(popupRef.querySelectorAll(".k-list-item-text")).filter((item) =>
    item.innerText.toLowerCase()?.startsWith(filterText.toLowerCase())
  );

  if (filteredItems?.length > 0) {
    filteredItems[0].scrollIntoView({ block: "start" });
  } else {
    const options = Array.from(popupRef?.querySelectorAll(".k-list-item-text"));
    options?.[0].scrollIntoView({ block: "start" });
  }
}

export const ExclusionFilterProperty = {
  propertyName: "ExclusionFilter",
  propertyDisplay: "Exclusion Filter",
  propertyType: "array",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <div className="k-d-flex k-flex-col k-w-full">
        <div className="k-pl-5">
          <Label>
            Data Connection: &nbsp;
            <CustomDropDown
              handlePropertyChange={handlePropertyChange}
              currentPropertyValues={currentPropertyValues}
              propertyName={this.propertyName}
            />
          </Label>
          <Label>
            Value Map: &nbsp;
            <ComboBox
              className="!k-w-full"
              data={
                typeof currentPropertyValues?.ExclusionFilter?.columns === "object"
                  ? Array.from(
                      new Set(
                        Object.entries(currentPropertyValues?.ExclusionFilter?.columns)
                          .filter(([, value]) => value?.selected)
                          .map(([key]) => key)
                      )
                    )
                  : []
              }
              onChange={(e) => {
                handlePropertyChange({
                  propName: "ExclusionFilterValue",
                  propValue: e.target.value,
                });
              }}
              filterable={true}
              onFilterChange={(e) => {
                setTimeout(() => {
                  scrollToFilteredItem(e.filter.value);
                }, 0);
              }}
              defaultValue={currentPropertyValues?.ExclusionFilterValue || ""}
            />
          </Label>
        </div>
      </div>
    );
  },
};
